import { render, staticRenderFns } from "./ChecksTable.vue?vue&type=template&id=85018534"
import script from "./ChecksTable.vue?vue&type=script&lang=js"
export * from "./ChecksTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports